/* eslint-disable max-len */


import React, { useContext, useState, useEffect, useRef } from "react";
import RolesSelection from "../../../components/RolesSelection";
import GlobalContext from "../../../components/Context/GlobalContext";
import CardHeader from "../../../components/CardHeader";
import { validateEmail } from "../../../CommonMethods/EmailValidator";
import Button from "../../../components/Button";
import { dataService } from '../../../services/data.services'
import { useNavigate, useParams } from "react-router-dom";
import LoadingOverlay from 'react-loading-overlay-ts';
import ErrorMessage from "../../../components/ErrorMessage";
import CardHeaders from "../../../components/CardHeaders";
import FloatingInput from "../../../components/FloatinInput/FloatingInput";
import { AllRolesList, MerchantRoleList } from "../../../config/roles";
import MerchantRoleSelection from "./MerchantRoleSelection";

export default function AddAdminUser({ edit }) {
    const { setToastmessage, setToastErrorMessage, setToastError } = useContext(GlobalContext)
    const [loading, setloading] = useState(false);
    const [invalidEmail, setinvalidEmail] = useState('');
    const [editData, seteditdata] = useState({})
    const [checkedRoles, setCheckedRoles] = useState({})
    const [merchantRoles, setMerchantRoles] = useState({})
    const [tempData, setTempData] = useState({})
    const [originalEmail, setOriginalEmail] = useState(""); 
    const [emailChanged, setEmailChanged] = useState(false);
    const { id } = useParams()
    const ref = useRef();
    const nameRef = useRef();
    const phoneRef = useRef()
    const navigate = useNavigate()
    const [errorState, setErrorState] = useState({
        "name": "",
        "email_address": "",
        "phone_number": "",
        "admin_privileges": '',
    })
    const [state, setstate] = useState({
        "name": "",
        "email_address": "",
        "phone_number": "",
        "admin_privileges": [],
        "merchant_privileges": []
    });

    function constructRoleObject(apiResponse, mainRoleObject) {
        const constructedObject = {};

        for (const [key, value] of Object.entries(mainRoleObject)) {
            const subRoles = {};
            value.forEach(subRole => {
                if (subRole === 'update_store_setting') {
                    if (apiResponse.includes('update_store')) {
                        subRoles[subRole] = true;
                    }
                }
                if (apiResponse.includes(subRole)) {
                    subRoles[subRole] = true;
                }
            });

            if (Object.keys(subRoles).length > 0) {
                constructedObject[key] = subRoles;
            }
        }

        return constructedObject;
    }

    const getData = async () => {
        try {
            let res = await dataService.GetAPI(`admin-users/${id}`);
            delete res.data['adminuser_id'];
            delete res.data['status'];
            delete res.data['_id'];
            delete res?.data['user_type'];
            delete res?.data['update_at'];
            seteditdata(res?.data);
            setTempData(res?.data);
            setOriginalEmail(res?.data?.email_address); // Store original email
            setCheckedRoles(constructRoleObject(res?.data?.admin_privileges, AllRolesList))
            if (res?.data?.merchant_privileges) {
                setMerchantRoles(constructRoleObject(res?.data?.merchant_privileges, MerchantRoleList))
            }

            setstate(res.data);
        } catch (error) {
            setToastErrorMessage(error.message)
        }
    }

    useEffect(() => {
        if (edit) {
            getData()
        }
    }, [])

    const [submitSelected, setsubmitSelected] = useState(false)
    
    const handleInput = (id, value) => {
        setinvalidEmail('')
        setToastErrorMessage('')
        
        const phoneNumberRegex = /^\+?\d{0,15}$/;
        const nameEx = /^[a-zA-Z\s_]*$/;
        
        if (id === 'phone_number' && value !== '') {
            if (!phoneNumberRegex.test(value)) {
                return;
            }
        }
        if (id === 'name' && value !== '') {
            if (!nameEx.test(value)) {
                return;
            }
        }
        
        // Check if email is being changed
        if (id === 'email_address' && edit) {
            setEmailChanged(value !== originalEmail);
        }

        setstate((prv) => ({
            ...prv,
            [id]: value
        }))
    }
    
    const handleValidation = () => {
        const arr = []
        const mykeys = {
            "name": "",
            "email_address": "",
            "phone_number": "",
        }
        Object.keys(mykeys).map((item) => {
            if (typeof state[item] === 'object' ? state[item].length === 0 : state[item] === '') {
                arr.push(item)
            }
        })
        return arr.length === 0
    }
    
    const handleSubmit = async (e) => {
        e.preventDefault();
        setloading(true);
        setinvalidEmail('');
        setErrorState({
            "name": "",
            "email_address": "",
            "phone_number": "",
            "admin_privileges": ''
        });
        setsubmitSelected(true);
        
        state.name = state.name.trim();
        state.email_address = state.email_address.trim();
        state.phone_number = state.phone_number.trim();
        
        if (!handleValidation()) {
            setloading(false);
            return;
        }
    
        // This now correctly uses your validateEmail function
        if (validateEmail(state.email_address)) {
            setinvalidEmail('Invalid email address');
            setErrorState({
                ...errorState,
                email_address: 'Invalid email address'
            });
            setloading(false);
            return;
        }
        
        // Continue with the rest of your submit logic
        if (state?.admin_privileges?.length === 0) {
            setToastError('Choose at least one admin privilege');
            setloading(false);
            return;
        }
    

        // Check if data has changed - if not, return
        if (JSON.stringify(tempData) === JSON.stringify(state) && !emailChanged) {
            setloading(false);
            return;
        }
        
        try {
            // Create a clean object with only the fields the API expects
            const body = {
                name: state.name.trim(),
                email_address: state.email_address.trim(),
                phone_number: state.phone_number.trim(),
                admin_privileges: state.admin_privileges,
                merchant_privileges: state.merchant_privileges
            };
            
            // No need to delete fields since we're only including what we need
            
            let response;
            if (edit) {
                response = await dataService.PatchAPI(body, `admin-users/update/${id}`);
            } else {
                response = await dataService.PostAPI(body, `admin-users/create`);
            }
            
            const successMessage = edit 
                ? `Admin user updated successfully${emailChanged ? '. A verification email will be sent to the new address' : ''}`
                : 'Admin user added successfully';
                
            setToastmessage(successMessage);
            navigate('/manage-admin-users');

        } catch (error) {
            setloading(false);
            const errorMsg = error.response?.data?.message || "An error occurred";
            setToastError(errorMsg);
        }
    }
    
    // Check if any data has changed including email
    const hasDataChanged = () => {
        if (emailChanged) return true;
        
        const tempDataCopy = {...tempData};
        const stateCopy = {...state};
        
        // Temporarily remove email for comparison if it has changed
        if (emailChanged) {
            tempDataCopy.email_address = stateCopy.email_address;
        }
        
        return JSON.stringify(tempDataCopy) !== JSON.stringify(stateCopy);
    }
    
    return (
        <CardHeaders paths={['Admin User']} pathurls={['/manage-admin-users']} activePath={edit ? 'Edit Admin User' : "Add Admin User"} header={edit ? 'Edit Admin User' : "Add Admin User"} back="/manage-admin-users">
            <LoadingOverlay
                active={edit ? Object.keys(editData).length === 0 : false}
                spinner
                text='Loading Admin user details...'
            >
                <div className="bg-[#f5f5f5] pl-[15px] py-[14px] ">
                    <div className="bg-white relative">
                        <div className="h-privilageHeight overflow-auto overflow-x-hidden custom-scrollbar p-4">
                            <div className="pt-5 mb-[22px]">
                                <p className="text-base font-semibold text-[#7D7D7D]">
                                    Basic Details
                                </p>
                            </div>
                            <form onSubmit={handleSubmit}>
                                <div className="flex space-x-6 mb-[43px] w-[100%]">
                                    <div className='relative w-full'>
                                        <FloatingInput
                                            submitSelected={submitSelected}
                                            setsubmitSelected={setsubmitSelected}
                                            value={state?.name}
                                            id="name"
                                            handleInput={handleInput}
                                            state={state.name}
                                            classKey={`${submitSelected && !loading && (state.name.trim() === '' || (errorState['name'] && errorState['name'] !== ''))
                                                ? "input-error"
                                                : "input-border"
                                            } w-full pl-3 pr-[56px] pt-4 rounded h-[56px] focus:outline-none focus:ring-0 focus:border-[#333232] peer `}
                                            labelCalss={`${submitSelected && !loading && (state.name.trim() === '' || (errorState['name'] && errorState['name'] !== '')) ? 'text-[#FC4523] ' : 'text-[#1F1F1F]'} px-3 left-1 absolute text-[#1F1F1F] block font-semibold font-normal leading-tigh text-base duration-300 transform -translate-y-3 scale-75 top-4 z-10 origin-[0] peer-focus:text-[#1F1F1F] peer-focus:dark: peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-3`}
                                            text="Name"
                                            errorState={errorState}
                                            placeholder={edit ? ' ' : ''}
                                            maxLength="64"
                                        />
                                    </div>
                                    <div className="relative w-full">
                                        <FloatingInput
                                            submitSelected={submitSelected}
                                            setsubmitSelected={setsubmitSelected}
                                            value={state.email_address}
                                            id="email_address"
                                            handleInput={handleInput}
                                            state={state.email_address}
                                            classKey={`${submitSelected && !loading && (state.email_address.trim() === '' || (errorState['email_address'] && errorState['email_address'] !== ''))
                                                ? "input-error"
                                                : "input-border"
                                            } w-full pl-3 pr-[45px] pt-4 rounded h-[56px] focus:outline-none focus:ring-0 focus:border-[#333232] peer`}
                                            labelCalss={`${submitSelected && !loading && (state.email_address.trim() === '' || (errorState['email_address'] && errorState['email_address'] !== '')) ? 'text-[#FC4523] ' : 'text-[#1F1F1F]'} px-3 left-1 font-semibold absolute text-[#1F1F1F] block font-normal leading-tigh text-base duration-300 transform -translate-y-3 scale-75 top-4 z-10 origin-[0] peer-focus:text-[#1F1F1F] peer-focus:dark: peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-3`}
                                            text="Email address"
                                            errorState={errorState}
                                            placeholder={edit ? ' ' : ''}
                                            maxLength={64}
                                        />
                                        <button type="button" className={`cursor-pointer absolute ${submitSelected && (state.email_address === '' || validateEmail(state.email_address || invalidEmail !== '')) ? 'top-[35%]' : 'top-[50%]'} -translate-y-[50%] right-3.5`}>
                                            <img loading="lazy" src={`/assets/images/${submitSelected && (state.email_address === '' || validateEmail(state.email_address || invalidEmail !== '')) ? 'email-error.svg' : 'email.svg'}`} alt="password-show" className="password-show" />
                                        </button>
                                        {/* {edit && emailChanged && (
                                            <p className="text-xs text-blue-600 mt-1">Email will be updated and verification might be required</p>
                                        )} */}
                                    </div>
                                    <div className="relative w-full">
                                        <FloatingInput
                                            submitSelected={submitSelected}
                                            setsubmitSelected={setsubmitSelected}
                                            value={state?.phone_number}
                                            id="phone_number"
                                            handleInput={handleInput}
                                            state={state.phone_number}
                                            classKey={`${submitSelected && !loading && (state.phone_number.trim() === '' || (errorState['phone_number'] && errorState['phone_number'] !== ''))
                                                ? "input-error"
                                                : "input-border"
                                            } w-full pl-3 pr-[56px] pt-4 rounded h-[56px] focus:outline-none focus:ring-0 focus:border-[#333232] peer `}
                                            labelCalss={`${submitSelected && !loading && (state.phone_number.trim() === '' || (errorState['phone_number'] && errorState['phone_number'] !== '')) ? 'text-[#FC4523] ' : 'text-[#1F1F1F]'} px-3 left-1 absolute text-[#1F1F1F] block font-semibold font-normal leading-tigh text-base duration-300 transform -translate-y-3 scale-75 top-4 z-10 origin-[0] peer-focus:text-[#1F1F1F] peer-focus:dark: peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-3`}
                                            text="Phone number"
                                            errorState={errorState}
                                            placeholder={edit ? ' ' : ''}
                                            maxLength="15"
                                        />
                                        <img
                                            className="absolute top-[16px] right-[15px] cursor-pointer "
                                            src="/assets/images/phone.svg"
                                            alt=""
                                        />
                                    </div>
                                </div>
                            </form>
                            <div className="mb-[22px]">
                                <p className="text-base font-semibold text-[#7D7D7D]">Admin Privileges</p>
                            </div>
                            <RolesSelection
                                error={submitSelected}
                                handleValidation={handleValidation}
                                state={state}
                                setstate={setstate}
                                checkedRoles={checkedRoles}
                                setCheckedRoles={setCheckedRoles}
                            />
                            <div className="mb-2 mt-2">
                                <p className="text-base font-semibold text-[#7D7D7D]">Merchant Privileges</p>
                            </div>
                            <MerchantRoleSelection
                                error={submitSelected}
                                handleValidation={handleValidation}
                                state={state}
                                setstate={setstate}
                                checkedRoles={merchantRoles}
                                setCheckedRoles={setMerchantRoles}
                            />
                            <div className="flex items-end justify-start z-100">
                                <Button
                                    classKey={` w-[32%] bg-primary flex justify-center ${(!hasDataChanged()) ? 'opacity-[0.3]':''} items-center py-[10px] mb-4 text-white rounded-[12px] ${!handleValidation() ? 'opacity-[0.3]' : ''}`}
                                    disabled={!handleValidation() || loading || (!hasDataChanged())}
                                    text={edit ? 'Update' : "Add"}
                                    type="submit"
                                    loading={loading}
                                    handleClick={handleSubmit}
                                    testId="add-btn"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </LoadingOverlay>
        </CardHeaders>
    );
}